import { Component } from 'react'
import { number, shape, func, object, string, bool, arrayOf } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  setText,
  setPhoneMessage,
  setSMSMessage,
  setEmailMessage,
} from './../../store/MessageCreate/actionCreator'
import { TextField, withStyles } from '@material-ui/core'
import { formValidation } from './formValidation'

const styles = (theme) => ({
  form: {
    textAlign: 'center',
  },
  button: {
    marginLeft: 15,
  },
  textField: {
    width: '90%',
  },
})

export class MessageCreateForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageTitle: this.props.fromParentTitleData,
      messageTitleErrorMsg: formValidation(
        this.props.fromParentTitleData,
        'text',
        'text',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      messageTitleError: formValidation(
        this.props.fromParentTitleData,
        'text',
        'boolean',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      messagePhone: this.props.fromParentPhoneMessageData,
      messagePhoneErrorMsg: formValidation(
        this.props.fromParentPhoneMessageData,
        'text',
        'text',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      messagePhoneError: formValidation(
        this.props.fromParentPhoneMessageData,
        'text',
        'boolean',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      messageSMS: this.props.fromParentSMSMessageData,
      messageSMSErrorMsg: formValidation(
        this.props.fromParentSMSMessageData,
        'text',
        'text',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      messageSMSError: formValidation(
        this.props.fromParentSMSMessageData,
        'text',
        'boolean',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      messageEmail: this.props.fromParentEmailMessageData,
      messageEmailErrorMsg: formValidation(
        this.props.fromParentEmailMessageData,
        'text',
        'text',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      messageEmailError: formValidation(
        this.props.fromParentEmailMessageData,
        'text',
        'boolean',
        this.props.fromParentCountryLinkRestrictionFlag,
      ),
      contactMethods: this.props.fromParentContactMethods,
      countryLinkRestrictionFlag:
        this.props.fromParentCountryLinkRestrictionFlag,
      isTemplate: this.props.fromParentIsTemplate,
    }
    this.handleChange = this.handleChange.bind(this)
  }

  getContactMethods(JSONcontactData, contactMethodSelected) {
    // Match item in map to provided contact Method
    var result = false
    JSONcontactData.filter((item) => item.text === contactMethodSelected).map(
      (item, i) => {
        result = item.checked
        return result
      },
    )
    return result
  }

  handleChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    const {
      setText,
      countryLinkRestrictionFlag,
      fromParentCountryLinkRestrictionFlag,
      callbackFromParentTitle,
      callbackFromParentTitleData,
      setPhoneMessage,
      callbackFromParentPhoneMessage,
      callbackFromParentPhoneMessageData,
      setSMSMessage,
      callbackFromParentSMSMessage,
      callbackFromParentSMSMessageData,
      callbackFromParentEmailMessage,
      callbackFromParentEmailMessageData,
    } = this.props

    this.setState({
      [name]: value,
    })
    if (name === 'messageTitle') {
      setText(value)
      if (
        formValidation(value, 'text', 'boolean', countryLinkRestrictionFlag) ===
        false
      ) {
        this.setState({
          messageTitleError: false,
        })
        callbackFromParentTitle(false)
        this.setState({
          messageTitleErrorMsg: '',
        })
      } else {
        this.setState({
          messageTitleError: true,
        })
        callbackFromParentTitle(true)
        this.setState({
          messageTitleErrorMsg: formValidation(
            value,
            'text',
            'text',
            fromParentCountryLinkRestrictionFlag,
          ),
        })
      }
      callbackFromParentTitleData(value)
    }
    if (name === 'messagePhone') {
      setPhoneMessage(value)
      if (
        formValidation(value, 'text', 'boolean', countryLinkRestrictionFlag) ===
        false
      ) {
        this.setState({
          messagePhoneError: false,
        })
        callbackFromParentPhoneMessage(false)
        this.setState({
          messagePhoneErrorMsg: '',
        })
      } else {
        this.setState({
          messagePhoneError: true,
        })
        callbackFromParentPhoneMessage(true)
        this.setState({
          messagePhoneErrorMsg: formValidation(
            value,
            'text',
            'text',
            fromParentCountryLinkRestrictionFlag,
          ),
        })
      }
      callbackFromParentPhoneMessageData(value)
    }
    if (name === 'messageSMS') {
      setSMSMessage(value)
      var isError = formValidation(
        value,
        'text',
        'boolean',
        countryLinkRestrictionFlag,
      )
      this.setState({
        messageSMSError: isError,
      })
      callbackFromParentSMSMessage(isError)
      this.setState({
        messageSMSErrorMsg: formValidation(
          value,
          'text',
          'text',
          fromParentCountryLinkRestrictionFlag,
        ),
      })
      callbackFromParentSMSMessageData(value)
    }
    if (name === 'messageEmail') {
      setEmailMessage(value)
      if (
        formValidation(value, 'text', 'boolean', countryLinkRestrictionFlag) ===
        false
      ) {
        this.setState({
          messageEmailError: false,
        })
        callbackFromParentEmailMessage(false)
        this.setState({
          messageEmailErrorMsg: '',
        })
      } else {
        this.setState({
          messageEmailError: true,
        })
        callbackFromParentEmailMessage(true)
        this.setState({
          messageEmailErrorMsg: formValidation(
            value,
            'text',
            'text',
            fromParentCountryLinkRestrictionFlag,
          ),
        })
      }
      callbackFromParentEmailMessageData(value)
    }
  }

  render() {
    const { classes } = this.props
    const {
      contactMethods,
      messagePhone,
      messagePhoneError,
      messagePhoneErrorMsg,
      messageSMS,
      messageSMSError,
      messageSMSErrorMsg,
      messageEmail,
      messageEmailError,
      messageEmailErrorMsg,
      messageTitle,
      messageTitleError,
      messageTitleErrorMsg,
    } = this.state
    let messageFieldPhone = ''
    let messageFieldSMS = ''
    let messageFieldEmail = ''
    if (this.getContactMethods(contactMethods, 'Phone')) {
      messageFieldPhone = (
        <TextField
          name="messagePhone"
          id="message_phone"
          label="Message - Phone"
          multiline
          minRows="10"
          margin="normal"
          inputProps={{ maxLength: 600 }}
          value={messagePhone}
          onChange={this.handleChange.bind(this)}
          className={classes.textField}
          error={messagePhoneError}
          helperText={messagePhoneErrorMsg}
        />
      )
    }
    if (this.getContactMethods(contactMethods, 'SMS')) {
      messageFieldSMS = (
        <TextField
          name="messageSMS"
          id="message_sms"
          label="Message - SMS"
          multiline
          minRows="10"
          margin="normal"
          inputProps={{ maxLength: 600 }}
          value={messageSMS}
          onChange={this.handleChange.bind(this)}
          className={classes.textField}
          error={messageSMSError}
          helperText={messageSMSErrorMsg}
        />
      )
    }
    if (
      this.getContactMethods(contactMethods, 'Email')
      //  &&
      // !this.hideEmailBox()
    ) {
      messageFieldEmail = (
        <TextField
          name="messageEmail"
          id="message_email"
          label="Message - Email"
          multiline
          minRows="10"
          margin="normal"
          value={messageEmail}
          onChange={this.handleChange.bind(this)}
          className={classes.textField}
          error={messageEmailError}
          helperText={messageEmailErrorMsg}
        />
      )
    }
    return (
      <div className={classes.form}>
        <form>
          <br />
          <TextField
            name="messageTitle"
            id="message_title"
            label="Message Name"
            margin="normal"
            inputProps={{ maxLength: 50 }}
            value={messageTitle}
            onChange={this.handleChange.bind(this)}
            className={classes.textField}
            error={messageTitleError}
            helperText={messageTitleErrorMsg}
          />
          <br />
          {messageFieldPhone}
          {messageFieldSMS}
          {messageFieldEmail}
          <br />
        </form>
      </div>
    )
  }
}

MessageCreateForm.propTypes = {
  classes: object,
  callbackFromParentTitle: func.isRequired,
  callbackFromParentTitleData: func.isRequired,
  callbackFromParentPhoneMessage: func.isRequired,
  callbackFromParentPhoneMessageData: func.isRequired,
  callbackFromParentSMSMessage: func.isRequired,
  callbackFromParentSMSMessageData: func.isRequired,
  callbackFromParentEmailMessage: func.isRequired,
  callbackFromParentEmailMessageData: func.isRequired,
  fromParentTitleData: string.isRequired,
  fromParentContactMethods: arrayOf(
    shape({
      id: number.isRequired,
      text: string.isRequired,
      checked: bool.isRequired,
    }),
  ),
  fromParentPhoneMessageData: string.isRequired,
  fromParentSMSMessageData: string.isRequired,
  fromParentEmailMessageData: string.isRequired,
  fromParentCountryLinkRestrictionFlag: bool.isRequired,
  fromParentIsTemplate: bool.isRequired,
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setText,
      setPhoneMessage,
      setSMSMessage,
      setEmailMessage,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  messageTitle: state.messageCreate.inputText,
  messagePhone: state.messageCreate.inputPhoneMessage,
  messageSMS: state.messageCreate.inputSMSMessage,
  messageEmail: state.messageCreate.inputEmailMessage,
})
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(MessageCreateForm))
